<app-breadcrumb [breadcrumb]="breadcrumb"></app-breadcrumb>

<div
	class="row"
	*ngIf="loading">
	<div class="col text-center">
		<app-loader [material]="false"></app-loader>
	</div>
</div>

<div
	class="row"
	*ngIf="!loading && owner">
	<div class="col-sm-12">
		<app-card
			[hidHeader]="true"
			cardClass="tab-card">

			<nav
				ngbNav
				[navsetlink]="nav"
				#nav="ngbNav"
				class="nav-tabs">
				<ng-container ngbNavItem="dati">
					<a
						routerLink="."
						fragment="dati"
						ngbNavLink>
						Dati
					</a>
					<ng-template ngbNavContent>
						<table
							class="table"
							*ngIf="owner">
							<tbody>
								<tr>
									<td>{{ 'labels.id' | translate }}</td>
									<td>{{ owner.id }}</td>
								</tr>
								<tr>
									<td>{{ 'labels.fname' | translate }}</td>
									<td>{{ owner.fname }}</td>
								</tr>
								<tr>
									<td>{{ 'labels.lname' | translate }}</td>
									<td>{{ owner.lname }}</td>
								</tr>
								<tr>
									<td>{{'labels.company' | translate }}</td>
									<td>{{ company.name }}</td>
								</tr>
								<tr>
									<td>{{'labels.birthdate' | translate }}</td>
									<td>
										{{ owner.birthdate | date:'dd/MM/yyyy'}}
									</td>
								</tr>

								<tr *ngFor="let key of keys">
									<td>{{'labels.'+ key | translate }}</td>
									<td>{{ owner[key] }}</td>
								</tr>
								<tr>
									<td>{{'labels.insdate' | translate }}</td>
									<td>
										{{ owner.insdate | date:'dd/MM/yyyy - hh:mm:ss'}}
									</td>
								</tr>
								<tr>
									<td>{{'labels.moddate' | translate }}</td>
									<td>
										{{ owner.moddate | date:'dd/MM/yyyy - hh:mm:ss'}}
									</td>
								</tr>

								<div class="row mt-1">
									<div class="col">
										<button
											(click)="edit()"
											class="btn btn-primary">
											{{'labels.edit' | translate}}
										</button>

									</div>

								</div>
							</tbody>
						</table>
					</ng-template>
				</ng-container>
				<ng-container ngbNavItem="documenti">
					<a
						routerLink="."
						fragment="documenti"
						ngbNavLink>
						Documenti
					</a>
					<ng-template ngbNavContent>
						<app-attachments
							[extradata]="{'company' : owner?.companyid}"
							[card]="false"
							mediapath="download"
							[library]="true"
							entity="owner"
							[bootstrap]="true"
							(change)="attachmentsChanged()"
							[canvalidate]="canvalidate"
							[eid]="owner.id"></app-attachments>
					</ng-template>
				</ng-container>
			</nav>

			<div
				[ngbNavOutlet]="nav"
				class="mt-2"></div>

		</app-card>
	</div>
</div>

<div
	class="row"
	*ngIf="!loading && error">
	<div class="col-sm-12">
		<app-card [hidHeader]="true">{{'errors.loading.owner' | translate}}</app-card>

	</div>
</div>
